import $axios from '~/plugins/axios';
import { buildModule } from '../utils';
import { Api, Campaign, CampaignRequest } from '~/api';
import { Dict } from '~/helpers';

const api = $axios as Api;

export default buildModule()
	.withState({
		storedCampaigns: {} as Dict<Campaign>,
	})
	.withGetters({
		byId: state => (campaignId: number): Campaign | null => (
			state.storedCampaigns[campaignId] ?? null
		),
	})
	.withMutations({
		STORE_CAMPAIGN (state, campaign: Campaign) {
			state.storedCampaigns = {
				...state.storedCampaigns,
				[campaign.id]: campaign,
			};
		},
	})
	.withActions({
		async get ({ commit }, campaignId: number) {
			const { data } = await api.get(`/campaign/${ campaignId }`);

			commit('STORE_CAMPAIGN', data.payload);
		},
		async post ({ commit }, campaign: CampaignRequest) {
			const { data } = await api.post('/campaign', campaign);

			commit('STORE_CAMPAIGN', data.payload);
		},
		async update ({ commit }, { id, ...campaign }: {
			id: number;
		} & CampaignRequest) {
			const { data } = await api.put(`/campaign/${ id }`, campaign);

			commit('STORE_CAMPAIGN', data.payload);
		},
		async delete (_, id: number) {
			await api.delete(`/campaign/${ id }`);
		},
	});
